module.exports = __webpack_public_path__ + "static/media/184.372966ad.jpg";